import { createPortal } from 'react-dom';
import { Snackbar, Slide, Alert } from '@mui/material';
import useSnackbar from 'hooks/useSnackbar';

const GlobalSnackbar = () => {
    const { snackbarState, onClose } = useSnackbar();

    const component = (
        <Snackbar
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "center"
            }}
            autoHideDuration={snackbarState.duration}
            open={snackbarState.open}
            onClose={onClose}
            TransitionComponent={Slide}
        >
            <Alert variant="filled" onClose={onClose} severity={snackbarState.severity}>
                {snackbarState.message}
            </Alert>
        </Snackbar>
    );

    return createPortal(component, document.body);
};

export default GlobalSnackbar;
